import React from "react";
import { Panel } from "primereact/panel";

/**
 * BOF-76 — what every figure on the dashboard means, on the page (FR-057).
 *
 * The reference workbook defined some of these differently on different sheets (see
 * `contracts/workbook-parity.md`), so a reader coming from it needs to see where this screen's definitions
 * sit. Collapsed by default: it is reference, not headline.
 */
const DEFINITIONS: Array<[string, string]> = [
  ["Charge points", "Charge points that exist, and those online, on the last recorded day of the period. A standing, not a sum — never added up across days and never scaled by the 30-day lens."],
  ["Online", "A charge point reporting Available, Charging or Reserved — the same reading station owners see. Blocked, out of order, planned, unknown and removed charge points are not online."],
  ["Energy and sessions", "Sessions that ended in the period, by Berlin-local day, counted by the charging station they belong to — the same attribution as the other Station Performance views."],
  ["AC / DC", "From the power type of the charge point's connectors: DC if any connector is DC. Sessions on a charge point with no recorded power type are shown as unclassified, never guessed."],
  ["Per day", "Divided by the days of the period that have finished — never by its full length while it is still running."],
  ["Energy per session", "Energy divided by sessions that delivered energy; sessions with 0 kWh are excluded from the denominator."],
  ["Change", "The period's total against the previous period's total. Never computed on daily averages."],
  ["30-day adjusted", "Energy and sessions scaled to a 30-day month (× 30 ÷ days covered), so months of different length compare fairly. Charge-point counts and ratios are not scaled."],
  ["Running period", "Covers complete days only. Nothing is projected to the end of the period."],
];

const MeasureDefinitions: React.FC = () => (
  <Panel header="How these figures are defined" toggleable collapsed className="mt-3">
    <dl className="m-0">
      {DEFINITIONS.map(([term, text]) => (
        <div key={term} className="mb-2">
          <dt className="font-semibold text-900">{term}</dt>
          <dd className="ml-0 text-color-secondary text-sm">{text}</dd>
        </div>
      ))}
    </dl>
  </Panel>
);

export default MeasureDefinitions;
